import { z } from 'zod';

export const ApplicationTaskSchema = z.enum([
  'EnglishLanguage',
  'Employment',
  'References',
  'PersonalStatement',
  'ResearchProposal',
  'Funding',
  'ImmigrationHistory',
  'DiversityInclusion',
  'Representation',
  'Referral',
  'Declarations',
]);

export const ApplicationTaskConfigSchema = z.record(ApplicationTaskSchema, z.boolean()).optional();

export const ApplicationTaskFlagsSchema = z.object({
  enabled: z.boolean().optional(),
  default: z.boolean().optional(),
});

export const ApplyApplicationTaskConfigSchema = z.record(ApplicationTaskSchema, ApplicationTaskFlagsSchema);
